import React, { Component } from 'react'
import { connect } from 'react-redux'
import { storage } from '../../../../config/firebaseConfig';
import { createFloor } from '../../../../store/actions/floorActions';
import Loader from 'react-loader-spinner';
import * as MDICONS from '@material-ui/icons';
import { get } from 'lodash'
import ReactModal from 'react-modal';
import AddFilesModal from './AddFilesModal';
import { openUploadFilesModal } from '../../../../store/actions/projectActions';
class AddNewFloorModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            imgUrl: "",
            name: "",
            fileName: "",
            containsMap: false,
            toggle: true,
            addDigitalPlans: false,
            showUploadNewMap: false,
        }
    }

    /// README: GETTING USER INPUT
    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    onHandleSelectMap = (fileName) => {
        const { proid } = this.props.snagDetail;
        var floorRef = storage.ref(`/Projects/${proid}/files/${fileName}.png`);

        // Get the download URL
        floorRef.getDownloadURL().then(url => {
            this.setState({
                fileName,
                imgUrl: url
            });
        });

    }

    /// README: CREATING A NEW PART ACTION
    handleSubmit = (e) => {
        e.preventDefault();

        const { proid } = this.props.snagDetail;
        const { name, fileName, containsMap } = this.state;
        const { commons } = this.props;

        if ((containsMap === false) || (fileName.length > 0 && name.length > 0)) {
            this.props.createFloor(proid, name, containsMap ? fileName : '', containsMap);
        } else {
            alert(`You may have either missed selecting ${commons.assetPart} map or have not entered ${commons.assetPart} name`);
        }
    }

    /// README: PRESET THE PART BY SOME VALUE
    async componentDidMount() {
        console.log('inside')
        const { proid, imageFilesList } = await this.props.snagDetail;
        // console.log(imageFilesList.length);
        if (imageFilesList.length > 0) {
            console.log('inside component did mount')
            var fileName = imageFilesList[0];
            var floorRef = await storage.ref(`/Projects/${proid}/files/${fileName}.png`);

            // Get the download URL
            try {
                console.log('inside try block')
                await floorRef.getDownloadURL().then(url => {
                    this.setState({
                        fileName,
                        imgUrl: url
                    });
                });
            }
            catch (e) {
                console.log(e, "error")
            }

        }
    }
    handleClick = (e) => {
        this.setState({
            containsMap: !this.state.containsMap,
            toggle: !this.state.toggle,
        })

    }

    addDigitalPlans = (e) => {
        this.setState({
            [e.target.id]: !this.state.addDigitalPlans,
            containsMap: !this.state.containsMap,
        })
    }
    handleOpenModal = () => {
        this.props.openUploadFilesModal();
        this.setState({
            showUploadNewMap: true,

        });
    }
    handleCloseModal = () => {
        this.setState({ showUploadNewMap: false });
    }
   

    /// README: RENDER THE UI
    render() {
        const { imgUrl, name, fileName, containsMap, toggle } = this.state;
        const { modalTitleStyle, formLabelStyle, modalWidth, snagDetail, floor,
            assetPart, assetParts, uassetPart, uassetParts, drawing, alu, userData, modalStyles, project } = this.props;
        const { imageFilesList } = snagDetail;
        const hintMapToggletext = toggle ? `with a ${drawing}` : `without a ${drawing}`;
        const modeColor = containsMap ? "darkblue" : "darkgreen";
        const { accessMap } = snagDetail;
        const { uid, employeeid } = userData;
        const ueid = uid + employeeid;
        const { isCompanyInsider, createNewFloorAccess, uploadNewMapAccess } = alu;
        const { isMoreFilesSynced, isReportCreated } = project;
        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: seeing the state of form (do styling adjustments but be cautious with state)
        ///
        const { isFloorCreating } = this.props.floor;
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }
        const relevantSubmitComponent = isFloorCreating ?
            (<React.Fragment>
                <Loader
                    type="TailSpin"
                    color={this.props.themeColors.themeColor}
                    height={20}
                    width={20}
                />
                <br></br>
                <p style={textStyle}>Creating {assetPart}...</p>
                <br></br>
            </React.Fragment>)
            :
            (<button className="btn btn-dark btn-sm" style={{ borderRadius: '10px',marginRight:'5px' }} type="submit">Create a {assetPart}</button>);
        var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;
        var uploadNewMapButton = uploadNewMapAccess[accessLevel] ? (<button className="btn btn-dark btn-sm" style={{ borderRadius: '10px',marginRight:'5px' }} onClick={() => { this.handleOpenModal() }}>Upload new {drawing}</button>) : (<React.Fragment></React.Fragment>);

        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: return the form
        ///

        // Donot remove this condition.
            return (
                <div className="dynamicModalContainer">
                    <div className="dynamicModalSm">
                        <p style={modalTitleStyle}>New {assetPart}</p>
                        {/* <button className="btn btn-sm" onClick={this.handleClick}>
                            {toggle ? <div className="d-flex justify-content-start"><MDICONS.ToggleOff style={{ scale: "1.5" }} />&nbsp;&nbsp;<strong>Add {hintMapToggletext}?</strong> </div> : <div className="d-flex justify-content-start"><MDICONS.ToggleOn style={{ scale: "1.5" }} />&nbsp;&nbsp;<strong>Add {hintMapToggletext}?</strong></div>}
                        </button> */}
                        {/* <span className="badge ml-2" style={{ backgroundColor: `${modeColor}`, color: "whitesmoke", fontSize: '14px' }} role="button" onClick={this.handleClick}>Switch to {hintMapToggletext} </span> */}
                        {/* <br /><br /> */}
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-group text-left">
                                {/* <label htmlFor="inputText" style={modalTitleStyle}>{uassetPart} name</label> */}
                                <input type="text" className="form-control" id="name" onChange={this.handleChange} placeholder="Project segment name" required defaultValue={name} />
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="addDigitalPlans" onChange={this.addDigitalPlans} />
                                <label className="form-check-label" for="addDigitalPlans">Have a digital plan?</label>
                            </div>

                            <br></br>
                            {this.state.addDigitalPlans ? imgUrl === "" ? uploadNewMapButton :
                                <div className="form-group text-left">
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex flex-row">
                                            <div className="align-self-center">
                                                <label htmlFor="inputText" style={modalTitleStyle}>Select a {drawing} from the dropdown</label>
                                            </div>
                                        </div>
                                        <div className="d-flex flex-row">
                                            <div className="align-self-center">
                                                <div className="dropdown show">
                                                    <span className="btn btn-flat btn-sm dropdown-toggle border-bottom" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        {fileName.length > 25 ? `${fileName.substring(0, 25)}...` : `${fileName}`}
                                                    </span>
                                                    <div className="dropdown-menu border" aria-labelledby="dropdownMenuLink">
                                                        {imageFilesList ? imageFilesList.map((fileName, i) => (
                                                            <span style={{ fontSize: "13px" }} role="button" className="dropdown-item" key={i} onClick={() => { this.onHandleSelectMap(fileName) }} data-toggle="tooltip" data-placement="top" title={fileName}>
                                                                {fileName.length > 25 ? `${fileName.substring(0, 25)}...` : `${fileName}`}
                                                            </span>
                                                        )) : <React.Fragment />}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <img className="container" src={imgUrl} alt="" title="" width="300px" height="350px" />
                                </div>
                                : <React.Fragment />}
                                  {relevantSubmitComponent}
                            <br></br>
                            <br></br>
                        </form>
                    </div>
                    <ReactModal
                        style={modalStyles}
                        isOpen={this.state.showUploadNewMap && !isMoreFilesSynced === true}
                        onRequestClose={() => { this.handleCloseModal() }}
                        contentLabel="Upload new map"
                        ariaHideApp={false}
                    >
                        <button className="close" onClick={() => { this.handleCloseModal() }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <AddFilesModal snagDetail={snagDetail} />
                    </ReactModal>
                </div>
            );
        
        // if (this.state.addDigitalPlans === true && imgUrl === "") {
        //     return (
        //         <div className="dynamicModalContainer">
        //             <div className="dynamicModalSm">
        //                 <div className="alert alert-danger m-4" role="alert">
        //                     Please upload at least 1 {drawing} to continue creating a {assetPart}.
        //                 </div>
        //             </div>
        //         </div>
        //     )
        // }
        // else {
        //     return (
        //         <div className="dynamicModalContainer">
        //             <div className="dynamicModalSm">
        //                 <div className="spinner-border" role="status">
        //                     <span className="sr-only">Please wait while form opens up...</span>
        //                 </div>
        //             </div>
        //         </div>
        //     );
        // }
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        alu: state.alu,
        formLabelStyle: state.appControl.formLabelStyle,
        floor: state.floor,
        modalWidth: state.appControl.modalWidth,
        modalTitleStyle: state.appControl.modalTitleStyle,
        commons: state.commons,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        userData: state.firebase.profile,
        modalStyles: state.appControl.modalStyles,
        project: state.project,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createFloor: (proid, name, fileName, containsMap) => dispatch(createFloor(proid, name, fileName, containsMap)),
        openUploadFilesModal: () => dispatch(openUploadFilesModal()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddNewFloorModal)
